<template>
  <div class="fixed top-0 left-0 w-full bg-black h-screen font-sans login bg-opacity-75">
    <div class="container mx-auto h-full flex flex-1 justify-center items-center">
      <div class="w-full max-w-lg">
        <div class="leading-loose">
          <form class="max-w-sm m-4 p-10 bg-white rounded shadow-xl text-center">
            <font-awesome-icon class="text-5xl mb-8" icon="unlink"></font-awesome-icon>

            <p class="font-medium text-center text-xl font-bold mb-2">Your session has expired</p>
            <p class="font-medium text-center">If you want to continue session as <span class="font-bold">{{ username }}</span>, please re-write your password</p>
            <div class="mt-2">
              <label class="block  text-sm text-white">Password</label>
              <input v-model="password" class="p-3 placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline w-full"
                     type="password" id="password" placeholder="Password" arial-label="password" required>
            </div>

            <div class="mt-4 text-center mt-4">
              <button class="uppercase px-8 py-3 rounded bg-green-500 text-white w-full shadow-sm"
                      type="button"
                      @click="login">{{ 'Connexion' }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'auth-reconnect',

  data () {
    return {
      email: null,
      password: null
    }
  },
  computed: {
    ...mapGetters('user', {
      user: 'me'
    }),
    username () {
      return this.user.fname
    }
  },
  methods: {
    login () {
      this.$store.dispatch('user/login', {
        email: this.user.email,
        password: this.password
      }).then(() => {
        this.$notify({title: 'Success', message: 'The connection has been reestablished with success.', type: 'success'})
      }).catch((response) => {
        this.$notify.error({title: this.$root.$t('api.' + response.data.code + '.title'), message: this.$root.$t('api.' + response.data.code + '.message')})
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/auth/reconnect.vue